import classNames from 'classnames';

import Modal from '../Modal';

import { useAppSelector, useAppDispatch } from '../../redux/hooks';
import usePackageLimitModal from '../../hooks/usePackageLimitModal';
import { formatDisplayNumber } from '../../utils/format';

import { setClosePackageLimitModal } from './PackageLimitModalSlice';

export default function PackageLimitModal() {
  const { isPackagesLoading, packages, currentPage } = usePackageLimitModal();
  const dispatch = useAppDispatch();
  const { open } = useAppSelector((state) => state.packageLimit);

  const onClose = () => {
    dispatch(setClosePackageLimitModal());
  };

  return (
    <Modal
      isOpen={open}
      onCloseModal={onClose}
      title="Quản lý nhiều mã chứng khoán hơn!"
      mainContentClassName="max-w-[96vw] xl:max-w-[70vw] m-auto w-full"
      isLoading={isPackagesLoading}
      modalClassName="limit-modal"
    >
      <div className="relative">
        <p className="text-gray-700 dark:text-gray-400 text-sm">
          Gói dịch vụ của bạn đã đạt giới hạn, bạn không thể thêm mới mã chứng
          khoán hoặc danh mục quản lý. Hãy nâng cấp gói dịch vụ để có thể sử
          dụng nhiều hơn. Hiện tại, gói dịch vụ của bạn gồm:{' '}
        </p>
        <ul className="mt-3 list-disc	ml-8">
          <li>
            Quản lý tối đa{' '}
            {formatDisplayNumber(currentPage?.investment_count || 0)} mã chứng
            khoán.
          </li>
          <li>
            Tạo tối đa{' '}
            {formatDisplayNumber(currentPage?.investment_category_count || 0)}{' '}
            danh mục theo dõi.
          </li>
          <li>
            Mỗi danh mục theo dõi có tối đa{' '}
            {formatDisplayNumber(
              currentPage?.investment_for_each_category || 0
            )}{' '}
            mã chứng khoán.
          </li>
        </ul>
        <h3 className="text-gray-700 dark:text-gray-400 text-base font-bold mt-6">
          Các gói dịch vụ hiện có.
        </h3>
        <div className="flex mt-3 flex-wrap slg:flex-nowrap">
          {packages?.map((item, index) => (
            <div
              className={classNames(
                'w-full mb-3 slg:mb-0 slg:w-1/3 flex flex-col justify-center col-span-1 py-3 px-6 space-y-6 bg-white rounded-lg shadow-md border border-solid package-item cursor-pointer',
                index < packages?.length ? 'mr-0 slg:mr-2' : ''
              )}
              key={item.id}
            >
              <div className="flex-shrink-0 pb-6 space-y-2 border-b">
                <h3>
                  <span className="uppercase text-lg font-bold">
                    {item.package_name}
                  </span>
                </h3>
              </div>
              <div className="flex items-center rounded-xl mt-2 flex-shrink-0">
                <h6 className="font-bold text-lg mr-1">
                  {formatDisplayNumber(item.price)}đ
                </h6>
                <p>/{item.duration} tháng</p>
              </div>
              <ul className="flex-1 space-y-4">
                <li className="flex gap-x-3 text-sm items-start">
                  <svg
                    className="h-6 w-5 flex-none text-indigo-600"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <span>
                    Quản lý tối đa {formatDisplayNumber(item.investment_count)}{' '}
                    mã chứng khoán
                  </span>
                </li>
                <li className="flex gap-x-3 text-sm items-start">
                  <svg
                    className="h-6 w-5 flex-none text-indigo-600"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <span>
                    Tạo tối đa{' '}
                    {formatDisplayNumber(item.investment_category_count)} danh
                    mục theo dõi
                  </span>
                </li>
                <li className="flex gap-x-3 text-sm items-start">
                  <svg
                    className="h-6 w-5 flex-none text-indigo-600"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <span>
                    Mỗi danh mục theo dõi có tối đa{' '}
                    {formatDisplayNumber(item.investment_for_each_category)} mã
                    chứng khoán
                  </span>
                </li>
                <li className="flex gap-x-3 text-sm items-start">
                  <svg
                    className="h-6 w-5 flex-none text-indigo-600"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <span>Cảnh báo/Thông báo nâng cao</span>
                </li>
              </ul>
              <div className="flex-shrink-0 px-3">
                <a
                  href={`/upgrade?id=${item.id}`}
                  className="px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-primary-main border border-transparent rounded-lg active:bg-purple-600 hover:bg-purple-700 focus:outline-none focus:shadow-outline-purple w-full block text-center"
                >
                  Nâng cấp
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}
